import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    remitos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    filtroOpcion: 1,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,
    remitoDestino: null,
    remitoEstado: null,
    contacto: '',
    provincia: null,
    localidad: null,
    transporte: null,
    entregaPersonal: false,
    usuario: null,
    numeroPresupuesto: 0,
    numeroOrdenTrabajo: 0,
    remitoEstadoPresupuesto: null,
    incluirAnulados: false,
    sortByDescending: true,
    numero: 0,
    numeroPuntoVenta: 0,

    remitosSeleccionados: [],
    seleccionados: false,
    seleccionadosIndeterminado: false,

    rptRemitos: [],
    list: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.remitos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroOpcion = 1;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.cliente = null;
        state.remitoDestino = null;
        state.remitoEstado = null;
        state.contacto = '';
        state.provincia = null;
        state.localidad = null;
        state.transporte = null;
        state.entregaPersonal = false;
        state.usuario = null;
        state.numeroPresupuesto = 0;
        state.numeroOrdenTrabajo = 0;
        state.remitoEstadoPresupuesto = null;
        state.incluirAnulados = false;
        state.sortByDescending = true;
        state.numero = 0;
        state.numeroPuntoVenta = 0;
    
        state.remitosSeleccionados = [];
        state.seleccionados = false;
        state.seleccionadosIndeterminado = false;
    },

    'INICIALIZAR_REMITOS' (state) {
        state.remitos = [];
    },
    'SET_REMITOS' (state, remitos) {
        state.remitos = remitos.map(remito => (
            { ...remito,
                // fechaEntrega: moment(remito.fechaEntrega).format('YYYY-MM-DD') == '1900-01-01' ? remito.fechaEntregaEstimada : remito.fechaEntrega,
                // isFechaEntregaEstimada: moment(remito.fechaEntrega).format('YYYY-MM-DD') == '1900-01-01' & moment(remito.fechaEntregaEstimada).format('YYYY-MM-DD') != '1900-01-01',
                selected: false,
                // _showDetails: remito.presupuestoInternoId != 0, 
                _showDetails: true,
                tienePresupuesto: remito.presupuestoInternoId != 0, 
                details: [
                    {
                        interno: remito.remitoInterno,
                        presupuestoNumero: remito.presupuestoNumero,
                        presupuestoInterno: remito.presupuestoInterno,
                        cantidadPallets: remito.cantidadPallets,
                        cantidadBultos: remito.cantidadBultos,
                        cantidadPaquetes: remito.cantidadPaquetes
                    }
                ],
                anulado: moment(remito.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' ? false : true,
                pendienteImpresion: (moment(remito.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' 
                    & !(/true/i).test(remito.remitoInterno)
                    & remito.comprobante.toString().substr(-8) == '00000000') ? true : false,
                _rowVariant: getRowVariant(remito)
                // _rowVariant: (moment(remito.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' 
                //     & !(/true/i).test(remito.remitoInterno)
                //     & remito.comprobante.toString().substr(-8) == '00000000') ? 'danger' : ''  
            }
        ));

        /* Recuperamos la lista de remitos seleccionados */
        if (state.remitosSeleccionados) {
            state.remitos.forEach(remito => {
                let remitoSelected = state.remitosSeleccionados.find(t => t.id == remito.id);
                if (remitoSelected) {
                    remito.selected = true;
                }
            });
        }

        validarRemitosSeleccionados(state);
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_REMITOS_SELECCIONADOS'(state) {
        state.remitosSeleccionados = [];
        state.seleccionados = false;
        state.seleccionadosIndeterminado = false;
        
        state.remitos.forEach(remito => remito.selected = false);
    },
    'ADD_REMITO_SELECCIONADO' (state, remito) {
        remito.selected = true;

        let itemKey = state.remitosSeleccionados
            .findIndex(t => t == remito);

        if (itemKey == -1) {
            state.remitosSeleccionados.push(remito);
        }

        validarRemitosSeleccionados(state);
    },
    'ACTUALIZAR_REMITO_SELECCIONADO' (state, remito) {
        if (remito.selected) {
            let itemKey = state.remitosSeleccionados
                .findIndex(remitoSeleccionado => remitoSeleccionado.id == remito.id);

            if (itemKey == -1) {
                state.remitosSeleccionados.push(remito);
            }
        } else {
            let itemKey = state.remitosSeleccionados
                .findIndex(remitoSeleccionado => remitoSeleccionado.id == remito.id);
    
            if (itemKey != -1) {
                state.remitosSeleccionados.splice(itemKey, 1);
            }
        }

        validarRemitosSeleccionados(state);
    },
    'ACTUALIZAR_SELECCION' (state) {
        state.remitos.forEach(remito => {
            remito.selected = !(/true/i).test(state.seleccionados);

            if (!(/true/i).test(state.seleccionados)) {
                let itemKey = state.remitosSeleccionados
                    .findIndex(remitoSeleccionado => remitoSeleccionado.id == remito.id);

                if (itemKey == -1) {
                    state.remitosSeleccionados.push(remito);
                }
            } else {
                let itemKey = state.remitosSeleccionados
                    .findIndex(remitoSeleccionado => remitoSeleccionado.id == remito.id);
        
                if (itemKey != -1) {
                    state.remitosSeleccionados.splice(itemKey, 1);
                }
            }
        });

        state.seleccionados = !state.seleccionados;
        state.seleccionadosIndeterminado = false;
    },


    // 'UPDATE_SELECCION'(state, params) {
    //     let selectedKey = state.remitosSeleccionados.findIndex(t => t.remitoId == params.remitoId);
    //     if ((/true/i).test(params.seleccionar)) {
    //         if (selectedKey == -1) {
    //             state.remitosSeleccionados.push({
    //                 remitoId: params.remitoId
    //             })

    //             let remito = state.remitos.find(t => t.id == params.remitoId);
    //             if (remito) {
    //                 remito.selected = true;
    //             }
    //         }
    //     } else {
    //         if (selectedKey != -1) {
    //             state.remitosSeleccionados.splice(selectedKey, 1);

    //             let remito = state.remitos.find(t => t.id == params.remitoId);
    //             if (remito) {
    //                 remito.selected = false;
    //             }
    //         }
    //     }
    // },
    // 'CLEAR_SELECCION'(state) {
    //     state.remitosSeleccionados = [];
        
    //     /* Actualizamos la lista de remitos */
    //     state.remitos.filter(t => t.selected).forEach(remito => {
    //         remito.selected = false;
    //     })
    // },

    'SET_TIENE_IMAGEN' (state, params) {
        let item = state.remitos
            .find(remito => remito.id == params.remitoId);

        if (item) {
            item.tieneImagenes = (/true/i).test(params.tieneImagenes);
        }
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, list) {
        state.list = list.map(remito => (
            { ...remito,
                tienePresupuesto: remito.presupuestoInternoId != 0, 
                presupuestoNumero: remito.presupuestoInternoId != 0? remito.presupuestoNumero : '',
                anulado: moment(remito.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' ? false : true
            }
        ));
    },
    'INICIALIZAR_RPT' (state) {
        state.rptRemitos = [];
    },
    'SET_RPT' (state, rptRemitos) {
        state.rptRemitos = rptRemitos;
    }
};

function getRowVariant(remito) {
    let estado = '';
    switch (remito.remitoEstadoId) {
        case 1: /* Pendiente*/
            estado = 'pendiente';
            break;
        case 2: /* En preparacion*/
            estado = 'en-preparacion';    
            break;
        case 3: /* En camino*/
            estado = 'en-camino';    
            break;
        case 4: /* pausado*/
            estado = 'pausado';    
            break;
        case 5: /* pausado*/
            estado = 'entregado';    
            break;
        case 6: /* conformado*/
            estado = 'conformado';    
            break;
        default:
            estado = 'danger';
            break;
    }

    if (moment(remito.fechaAnulado).format('YYYY-MM-DD') == '1900-01-01' 
        && remito.comprobante.toString().substr(-8) == '00000000') {
            estado = `${estado} sin-numerar`;
    }

    return estado;
}

function validarRemitosSeleccionados (state) {
    /* Actualizamos el estado del check global */
    let existsSeleccionado = false;
    let existsNoSeleccionado = false;

    let seleccionado = state.remitos
        .find(remito => (/true/i).test(remito.selected) == Boolean(true));
    if (seleccionado) {
        existsSeleccionado = true;
    }

    /* Validamos segun la moneda del comprobante */
    let noSeleccionado = state.remitos
        .find(remito => (/true/i).test(remito.selected) == Boolean(false));
    if (noSeleccionado) {
        existsNoSeleccionado = true;
    }
    
    state.seleccionados = existsSeleccionado;
    state.seleccionadosIndeterminado = existsSeleccionado & existsNoSeleccionado ? true : false;
}


const getters = {
    getField,

    list (state) {
        return state.list;
    },
    listSeleccionados(state) {
        if (state.remitosSeleccionados) {
            let list = [];

            state.list.forEach(remito => {
                let remitoSelected = state.remitosSeleccionados.find(t => t.id == remito.id);
                if (remitoSelected) {
                    list.push(remito);
                }
            });

            return list;
        }

        return state.list;
    },
    rptRemitos (state) {
        return state.rptRemitos;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getRemitos ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REMITOS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual

            if ((/true/i).test(state.filtroOpcion == 1)) {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&sortByDescending='+ state.sortByDescending;
            
                if (state.remitoDestino) {
                    if (state.remitoDestino.id != 0) {
                        queryString += '&remitoDestinoId=' + state.remitoDestino.id;
                    }
                }
                if (state.remitoEstado) {
                    if (state.remitoEstado.id != 0) {
                        queryString += '&remitoEstadoId=' + state.remitoEstado.id;
                    }
                }
                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if (state.contacto) {
                    if (state.contacto.trim() != '') {
                        queryString += '&contacto=' + state.contacto.trim();
                    }
                }
                if (state.pais) {
                    if (state.pais.id != 0) {
                        queryString += '&paisId=' + state.pais.id;
                    }
                }
                if (state.provincia) {
                    if (state.provincia.id != 0) {
                        queryString += '&provinciaId=' + state.provincia.id;
                    }
                }
                if (state.localidad) {
                    if (state.localidad.id != 0) {
                        queryString += '&localidadId=' + state.localidad.id;
                    }
                }
                if (state.transporte) {
                    if (state.transporte.id != 0) {
                        queryString += '&transporteId=' + state.transporte.id;
                    }
                }
                if ((/true/i).test(state.entregaPersonal)) {
                    queryString += '&entregaPersonal=true';
                }
                if (state.usuario) {
                    if (state.usuario.id != 0) {
                        queryString += '&usuarioId=' + state.usuario.id;
                    }
                }
                if ((/true/i).test(state.incluirAnulados)) {
                    queryString += '&incluirAnulados=true';
                }
            } else if ((/true/i).test(state.filtroOpcion == 2)) {
                if (state.numeroPresupuesto) {
                    if (state.numeroPresupuesto != 0) {
                        queryString += '&numeroPresupuesto=' + state.numeroPresupuesto;
                    }
                }
                if (state.numeroOrdenTrabajo) {
                    if (state.numeroOrdenTrabajo != 0) {
                        queryString += '&numeroOrdenTrabajo=' + state.numeroOrdenTrabajo;
                    }
                }
                if (state.remitoEstadoPresupuesto) {
                    if (state.remitoEstadoPresupuesto.id != 0) {
                        queryString += '&remitoEstadoPresupuesto=' + state.remitoEstadoPresupuesto.id;
                    }
                }
            } else if ((/true/i).test(state.filtroOpcion == 3)) {
                queryString += '&numero=' + state.numero;

                if (state.numeroPuntoVenta != 0) {
                    queryString += '&numeroPuntoVenta=' + state.numeroPuntoVenta;
                }
            }
    
            apiAxios.get('remitos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_REMITOS', res.data);

                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },

    inicializarRemitosSeleccionados ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_REMITOS_SELECCIONADOS');
            resolve();
        })            
    },
    seleccionarRemito ( { commit }, remito ) {
        return new Promise((resolve, reject) => {
            commit('ADD_REMITO_SELECCIONADO', remito);
            resolve();
        })            
    },
    actualizarRemitoSeleccionado ( { commit }, remito ) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_REMITO_SELECCIONADO', remito);
            resolve();
        })            
    },
    actualizarSeleccion ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('ACTUALIZAR_SELECCION');
            resolve();
        })            
    },

    // updateSeleccion ( { commit }, params ) {
    //     commit('UPDATE_SELECCION', params);
    // },
    // clearSeleccion ( { commit } ) {
    //     commit('CLEAR_SELECCION');
    // },

    delete ( {}, remitoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`remitos/${remitoId}/delete`)
                .then(() => resolve())
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    setRemitoTieneImagen: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('SET_TIENE_IMAGEN', params);
            resolve();
        })
    },
    getList ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let queryString = ''

            if ((/true/i).test(state.filtroOpcion == 1)) {
                queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&sortByDescending='+ state.sortByDescending;
            
                if (state.remitoDestino) {
                    if (state.remitoDestino.id != 0) {
                        queryString += '&remitoDestinoId=' + state.remitoDestino.id;
                    }
                }
                if (state.remitoEstado) {
                    if (state.remitoEstado.id != 0) {
                        queryString += '&remitoEstadoId=' + state.remitoEstado.id;
                    }
                }
                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if (state.contacto) {
                    if (state.contacto.trim() != '') {
                        queryString += '&contacto=' + state.contacto.trim();
                    }
                }
                if (state.pais) {
                    if (state.pais.id != 0) {
                        queryString += '&paisId=' + state.pais.id;
                    }
                }
                if (state.provincia) {
                    if (state.provincia.id != 0) {
                        queryString += '&provinciaId=' + state.provincia.id;
                    }
                }
                if (state.localidad) {
                    if (state.localidad.id != 0) {
                        queryString += '&localidadId=' + state.localidad.id;
                    }
                }
                if (state.transporte) {
                    if (state.transporte.id != 0) {
                        queryString += '&transporteId=' + state.transporte.id;
                    }
                }
                if ((/true/i).test(state.entregaPersonal)) {
                    queryString += '&entregaPersonal=true';
                }
                if (state.usuario) {
                    if (state.usuario.id != 0) {
                        queryString += '&usuarioId=' + state.usuario.id;
                    }
                }
                if ((/true/i).test(state.incluirAnulados)) {
                    queryString += '&incluirAnulados=true';
                }
            } else if ((/true/i).test(state.filtroOpcion == 2)) {
                if (state.numeroPresupuesto) {
                    if (state.numeroPresupuesto != 0) {
                        
                        queryString = '?numeroPresupuesto=' + state.numeroPresupuesto;
                    }
                }
                if (state.numeroOrdenTrabajo) {
                    if (state.numeroOrdenTrabajo != 0) {
                        queryString += `${queryString.trim() == ''? '?' : '&'}numeroOrdenTrabajo= ${state.numeroOrdenTrabajo}`;
                    }
                }
                if (state.remitoEstadoPresupuesto) {
                    if (state.remitoEstadoPresupuesto.id != 0) {
                        queryString += `${queryString.trim() == ''? '?' : '&'}remitoEstadoPresupuesto= ${state.remitoEstadoPresupuesto.id}`;
                    }
                }
            } else if ((/true/i).test(state.filtroOpcion == 3)) {
                queryString = '?numero=' + state.numero;

                if (state.numeroPuntoVenta != 0) {
                    queryString += '&numeroPuntoVenta=' + state.numeroPuntoVenta;
                }
            }
    
            apiAxios.get('remitos/list' + queryString)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getRptRemitos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');
    
            apiAxios.get('remitos/rpt/resumen' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}